'use strict';

module.exports = function (x) {
	return (x && ((typeof x === 'symbol') || (x['@@toStringTag'] === 'Symbol'))) || false;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/es6-symbol/is-symbol.js
 ** module id = 26
 ** module chunks = 0
 **/